// npm i filepond --save
import * as FilePond from 'filepond'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

if(document.querySelector('.input-file-group')){

    FilePond.registerPlugin(FilePondPluginImagePreview)
    FilePond.registerPlugin(FilePondPluginFileValidateType)

    const filesGroups = document.querySelectorAll('.input-file-group')
   
    const nonce = document.querySelector('#_wpnonce')
    filesGroups.forEach(filesGroup => {
        const inputfile = filesGroup.querySelector('input[type=file]')
        const inputfilename = inputfile.getAttribute('name')
        const datatype = filesGroup.getAttribute('data-type')
        let tipos
        let aceptatipo
        if(datatype === 'doc')
            {
                tipos = ['application\/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', "application\/vnd.openxmlformats-officedocument.wordprocessingml.document","application/msword",'application/pdf']
                aceptatipo = {
                    'application\/vnd.ms-excel': '.xls',
                    "application/msword": '.docx',
                    "application/msword": '.doc',
                    'application/pdf': 'pdf',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
                }
            } else 
            {
                tipos = ['image/png', 'image/jpeg']    
                aceptatipo = {
                        'image/png': '.png',
                        'image/jpeg': '.jpg',
                    }
            }
        const pond = FilePond.create(inputfile, {
            allowFileTypeValidation: true,
			fileValidateTypeLabelExpectedTypesMap: aceptatipo,
			acceptedFileTypes: tipos,
        })

        console.log(inputfilename)
        
        FilePond.setOptions({
            labelFileLoading: 'carg',
            labelIdle: 'Sube aqui tus archivos.<span class="filepond--label-action"> Arrastra o Click</span>',
            labelFileProcessing: 'Subiendo..',
            labelFileProcessingAborted: 'Subida cancelada',
            labelFileProcessingComplete: 'Subida completada',
            labelFileProcessingError: 'Error al subir',
            labelFileProcessingRevertError: 'Error al revertir',
            labelTapToCancel: 'Cancelar',
            labelTapToRetry: 'Reintentar',
            labelTapToUndo: 'Deshacer',
            labelButtonProcessItem: 'SUBIR',
            labelButtonRetryItemProcessing: 'Reintentar..',
            labelFileTypeNotAllowed: 'Tipo de archivo invalido',
            fileValidateTypeLabelExpectedTypes: 'Acepta archivos del tipo {allButLastType} o {lastType}',
            ignoredFiles: ['.ds_store', 'thumbs.db', 'desktop.ini'],
            server: {
                url: path.value,
                timeout: 15000,
                process: {
                    url: './parts/shared/ajax-filepond.php',
                    method: 'POST',
                    withCredentials: false,
                    onload: (response) => {
                        let respuesta = JSON.parse(response);
                        const result = filesGroup.querySelector('.result')
                        if(result.value === ''){
                            result.value = respuesta[1].toString()
                        } else {
                            result.value = result.value + ',' + respuesta[1].toString()
                        }
                        
                        console.log(response)
                        
                        console.log(respuesta[1])
                    
                    },
                    onerror: (response) => console.log(response),
                    ondata: (formData) => {
                        formData.append('id', 0);
                        formData.append('nonce', nonce.value);
                        formData.append('inputfilename', inputfilename);
                        console.log(formData);
                        return formData;
                    }
                },
              
                  
                
            }
            }
            )
    })
}